/** The fields needed to show a trailer; a `TrailerListItem` or any smaller trailer shape fits. */
export interface TrailerOption {
  id: number;
  name: string;
  licensePlate: string;
}

export const displayTrailer = (trailer: TrailerOption) => {
  return trailer.name ? `${trailer.name} - ${trailer.licensePlate}` : trailer.licensePlate;
};
